export default __webpack_public_path__ + "static/sandy_river-ce85076e610c3c93effcc58ff624286b.png";